import React from 'react';
import { LayerWrapper } from './LayerWrapper';
import type { BreakingNewsBannerLayer as BannerLayerConfig, TemplateFontStyle } from '../../types';

interface BreakingNewsBannerLayerProps {
  layer: BannerLayerConfig;
  breakingNewsText: string;
}

export function BreakingNewsBannerLayer({ layer, breakingNewsText }: BreakingNewsBannerLayerProps) {
  const {
    position,
    animation,
    opacity,
    backgroundColor,
    labelBackgroundColor,
    labelText,
    labelFont,
    textFont,
  } = layer;

  if (!breakingNewsText) return null;

  return (
    <LayerWrapper position={position} animation={animation} opacity={opacity}>
      <div
        style={{
          width: '100%',
          height: '100%',
          backgroundColor,
          display: 'flex',
          alignItems: 'center',
          overflow: 'hidden',
        }}
      >
        {/* Label pill */}
        <div
          style={{
            backgroundColor: labelBackgroundColor,
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            padding: '0 20px',
            flexShrink: 0,
          }}
        >
          <span style={fontToStyle(labelFont)}>{labelText}</span>
        </div>

        {/* Separator */}
        <div style={{ width: 1, height: '60%', backgroundColor: 'rgba(255,255,255,0.3)', flexShrink: 0 }} />

        {/* Breaking news text */}
        <div style={{ padding: '0 20px', overflow: 'hidden' }}>
          <span
            style={{
              ...fontToStyle(textFont),
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: 'block',
            }}
          >
            {breakingNewsText}
          </span>
        </div>
      </div>
    </LayerWrapper>
  );
}

function fontToStyle(font: TemplateFontStyle): React.CSSProperties {
  return {
    fontFamily: font.fontFamily,
    fontSize: font.fontSize,
    fontWeight: font.fontWeight,
    color: font.color,
    letterSpacing: font.letterSpacing,
    lineHeight: font.lineHeight,
    textTransform: font.textTransform,
  };
}
